import { BrandComplianceFormValues } from "interfaces/BrandCompliance";

export default function mapPropsToValues(): BrandComplianceFormValues {
  return {
    name: "",
    email: "",
    agencyId: "",
    otherCreativeAgency: "",
    isResubmission: "",
    referenceNumber: "",
    publicationType: [],
    submissionTitle: "",
    submissionSummary: "",
    hasExceptions: "",
    exceptionsSummary: "",
    hasTechnicalLimitations: "",
    technicalLimitationsSummary: "",
    hasCoBranding: "",
    hasLegalAgreement: "",
    isBrandIdentity: "",
    hasAiImagery: "",
    businessAreaId: "",
    functionalAreaId: "",
    verizonClientName: "",
    verizonDirectorName: "",
    verizonVpName: "",
    files: [],
    fileAssetTypes: {},
  };
}
